export default __webpack_public_path__ + "static/media/bira-carvalho-perfil.ce0e4032.jpg";